import { render, staticRenderFns } from "./SchoolAdminInterface.vue?vue&type=template&id=591c2696"
import script from "./SchoolAdminInterface.vue?vue&type=script&lang=js"
export * from "./SchoolAdminInterface.vue?vue&type=script&lang=js"
import style0 from "./SchoolAdminInterface.vue?vue&type=style&index=0&id=591c2696&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports